<div class="dialog-shell">

    <!-- Header -->
    <div class="dialog-header">
        <div class="flex items-start gap-4">
            <!-- Icon -->
            <div *ngIf="data.showIcon" class="dialog-icon" [ngClass]="data.type">
                <mat-icon *ngIf="data.type === 'danger' || data.type === 'warning' || data.type === 'error'"
                    [svgIcon]="'tabler_outline:alert-triangle'"></mat-icon>
                <mat-icon *ngIf="data.type === 'info'"
                    [svgIcon]="'tabler_outline:speakerphone'"></mat-icon>
                <mat-icon *ngIf="data.type === 'edit'"
                    [svgIcon]="'tabler_outline:edit'"></mat-icon>
                <mat-icon *ngIf="data.type === 'success'"
                    [svgIcon]="'tabler_outline:circle-check'"></mat-icon>
            </div>

            <!-- Text -->
            <div class="flex-1 min-w-0 pt-0.5">
                <h2 class="dialog-title">{{data.title}}</h2>
                <p class="dialog-message" [innerHTML]="data.message"></p>
            </div>

            <!-- Close -->
            <button mat-icon-button
                    class="dialog-close"
                    [matDialogClose]="undefined"
                    aria-label="Zamknij">
                <mat-icon [svgIcon]="'tabler_outline:x'" class="!w-4 !h-4"></mat-icon>
            </button>
        </div>
    </div>

    <!-- Body (formularze opcjonalne) -->
    <div *ngIf="data.inputs && data.inputs.length > 0" class="dialog-body">

        <form [formGroup]="form" class="space-y-3">
            <ng-container *ngFor="let input of data.inputs">
                <ng-container [ngSwitch]="input.type">

                    <mat-checkbox *ngSwitchCase="'checkbox'"
                                  [formControlName]="input.name"
                                  color="primary">
                        {{input.description}}
                    </mat-checkbox>

                    <mat-form-field *ngSwitchCase="'text'" class="w-full">
                        <mat-label>{{input.description}}</mat-label>
                        <input [formControlName]="input.name"
                               matInput
                               [placeholder]="input.description">
                    </mat-form-field>

                    <mat-form-field *ngSwitchCase="'date'" class="w-full">
                        <mat-label>{{input.description}}</mat-label>
                        <input [formControlName]="input.name"
                               matInput
                               type="date">
                        <mat-icon matPrefix svgIcon="tabler_outline:calendar"></mat-icon>
                    </mat-form-field>

                </ng-container>
            </ng-container>
        </form>
    </div>

    <!-- Footer -->
    <div class="dialog-footer" [ngClass]="'dialog-footer--' + data.type">
        <button *ngIf="data.cancelText != null"
                (click)="close(false)"
                class="dialog-btn dialog-btn--ghost">
            {{data.cancelText}}
        </button>
        <button mat-flat-button
                *ngIf="data.confirmText != null"
                (click)="close(true)"
                [disabled]="!form.valid"
                class="dialog-btn"
                [ngClass]="{
                    'dialog-btn--danger': data.type === 'warning' || data.type === 'error' || data.type === 'danger',
                    'dialog-btn--primary': data.type === 'info' || data.type === 'edit',
                    'dialog-btn--success': data.type === 'success'
                }">
            {{data.confirmText}}
        </button>
    </div>
</div>
